import React from "react";

interface VideoCamcorderIconProps {
  width?: string;
  height?: string;
  fill?: string;
  style?: React.CSSProperties;
}

const VideoCamcorderIcon: React.FC<VideoCamcorderIconProps> = ({
  width = "40",
  height = "40",
  fill = "#616161",
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3333 16.7614V11.6667C28.3333 8.90525 26.0948 6.66667 23.3333 6.66667H5C2.23858 6.66667 0 8.90525 0 11.6667V28.3333C0 31.0948 2.23858 33.3333 5 33.3333H23.3333C26.0948 33.3333 28.3333 31.0948 28.3333 28.3333V23.2387L37.3646 29.6896C37.8726 30.0524 38.5408 30.101 39.096 29.8153C39.6511 29.5296 40 28.9577 40 28.3333V11.6667C40 11.0424 39.6511 10.4704 39.096 10.1847C38.5408 9.89906 37.8726 9.94758 37.3646 10.3105L28.3333 16.7614ZM3.33333 11.6667C3.33333 10.7462 4.07953 10 5 10H23.3333C24.2538 10 25 10.7462 25 11.6667V28.3333C25 29.2538 24.2538 30 23.3333 30H5C4.07953 30 3.33333 29.2538 3.33333 28.3333V11.6667ZM36.6667 25.0947L29.5341 20L36.6667 14.9053V25.0947Z"
        fill={fill}
      />
    </svg>
  );
};

export default VideoCamcorderIcon;
